var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-control flex--col-center-start"},[_c('div',{staticClass:"flex--row-start-center",on:{"click":_vm.changeLocale}},[_c('Globe',{staticClass:"store-control__globe-icon",class:{ 'store-control__globe-icon--root': _vm.root },style:({ stroke: _vm.uiColor })})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }